<template>
  <div class="main-card mb-3 card">
    <div class="card-header">
      Platforms
      <div class="btn-actions-pane-right">
        <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
      </div>
    </div>
    <div class="card-body">
      <h5 class="card-title">Sales</h5>
      <ul class="list-platform select-list">
        <template v-for="(object, index) in data" :key="index">
          <li v-if="object.is_sales" class="checkbox-container">
            <input type="checkbox" name="options[platform]" :value="index" :checked="values.indexOf(index) !== -1" @click="changePlatform" /><span class="checkmark user">{{ object.label }}</span>
          </li>
        </template>
      </ul>
      <h5 class="card-title">Supplier</h5>
      <ul class="list-platform select-list">
        <template v-for="(object, index) in data" :key="index">
          <li v-if="object.is_supplier" class="checkbox-container">
            <input type="checkbox" name="options[platform]" :value="index" :checked="values.indexOf(index) !== -1" @click="changePlatform" /><span class="checkmark user">{{ object.label }}</span>
          </li>
        </template>
      </ul>
      <h5 class="card-title">Carrier</h5>
      <ul class="list-platform select-list">
        <template v-for="(object, index) in data" :key="index">
          <li v-if="object.is_carrier" class="checkbox-container">
            <input type="checkbox" name="options[platform]" :value="index" :checked="values.indexOf(index) !== -1" @click="changePlatform" /><span class="checkmark user">{{ object.label }}</span>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  computed: {
    storeId() {
      return 'main'
    },
    data() {
      return this.store.getter('data.platform', {})
    },
    values() {
      return Object.values(this.store.getter('values.platform', []))
    }
  },
  methods: {
    changePlatform(e) {
      let values = Object.values(this.values)
      if (e.target.checked == true) {
        values.push(e.target.value)
      } else if (values.indexOf(e.target.value) !== -1) {
        values.splice(values.indexOf(e.target.value), 1)
      }
      this.store.commit('values.platform', values)
    },
    handleClickSave() {
      this.$emit('submitSetting')
    }
  }
}
</script>

<style lang="scss">
body.page-general-option {
  .list-platform {
    padding: 0;
    margin: 0 -5px;
  }
}
</style>
